export default __webpack_public_path__ + "assets/images/g-icon5-d999b00e.svg";